'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.transformComprehension = transformComprehension;
exports.transformArrayComprehension = transformArrayComprehension;
exports.transformObjectComprehension = transformObjectComprehension;
exports.transformPlainArrayComprehension = transformPlainArrayComprehension;
exports.transformPlainObjectComprehension = transformPlainObjectComprehension;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _tails = require('./tails');

var _is = require('./is');

var _blocks = require('./blocks');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateComprehensionBody(path) {
  return path.traverse({
    noScope: true,

    Function(path) {
      path.skip();
    }, AwaitExpression(awaitPath) {
      throw awaitPath.buildCodeFrameError("`await` is not allowed within Comprehensions; " + "instead, await the Comprehension (eg; `y <- [for x of xs: x]`).");
    }, YieldExpression(yieldPath) {
      throw yieldPath.buildCodeFrameError("`yield` is not allowed within Comprehensions.");
    }, ReturnStatement(returnPath) {
      throw returnPath.buildCodeFrameError("`return` is not allowed within Comprehensions.");
    } });
}function iife(body, id, initializer) {
  var loc = (0, _astLocUtils.getSurroundingLoc)(body);

  body.unshift((0, _astLocUtils.placeAtNode)(_types2.default.variableDeclaration("const", [(0, _astLocUtils.placeAtNode)(_types2.default.variableDeclarator(id, initializer), id)]), id));
  body.push((0, _astLocUtils.placeAtLoc)(_types2.default.returnStatement(id), (0, _astLocUtils.span)(loc, -1)));

  return (0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.arrowFunctionExpression([], (0, _astLocUtils.placeAtLoc)(_types2.default.blockStatement(body), loc)), loc), []), loc);
}function retailObject(path, id, transformPathName, returnPathName) {
  var transformPath = path.get(transformPathName);
  validateComprehensionBody(transformPath);
  (0, _tails.transformTails)(transformPath, true, false, function (seqExpr, tailPath) {
    if (seqExpr.type !== "SequenceExpression" || seqExpr.expressions.length !== 2) {
      throw tailPath.buildCodeFrameError("Object comprehensions must end" + " with a (key, value) pair.");
    }
    var _seqExpr$expressions = _slicedToArray(seqExpr.expressions, 2),
        keyExpr = _seqExpr$expressions[0],
        valExpr = _seqExpr$expressions[1];

    return (0, _astLocUtils.placeAtNode)(_types2.default.assignmentExpression("=", (0, _astLocUtils.placeAtNode)(_types2.default.memberExpression(id, keyExpr, true), seqExpr), valExpr), seqExpr);
  });

  return path.get(returnPathName).node;
}function retailArray(path, id, transformPathName, returnPathName) {
  var transformPath = path.get(transformPathName);
  validateComprehensionBody(transformPath);
  (0, _tails.transformTails)(transformPath, true, false, function (expr) {
    return (0, _astLocUtils.placeAtNode)(_types2.default.callExpression((0, _astLocUtils.placeAtNode)(_types2.default.memberExpression(id, (0, _astLocUtils.placeAtNode)(_types2.default.identifier("push"), expr)), expr), [expr]), expr);
  });

  return path.get(returnPathName).node;
}function transformLoop(path, ref, isObject, stmts) {
  if (isObject) {
    return stmts.push(retailObject(path, ref, "loop.body", "loop"));
  } else {
    return stmts.push(retailArray(path, ref, "loop.body", "loop"));
  }
}function transformCase(path, ref, isObject, stmts) {
  if (isObject) {
    return stmts.push(retailObject(path, ref, "conditional", "conditional"));
  } else {
    return stmts.push(retailArray(path, ref, "conditional", "conditional"));
  }
}function pushBundle(stmts, ref, bundle, isObject) {
  if (isObject) {
    // _ref.k1 = v1; _ref.k2 = v2; ...
    for (var _i2 = 0, _len2 = bundle.length; _i2 < _len2; _i2++) {
      var _property = bundle[_i2];
      var loc = (0, _astLocUtils.getLoc)(_property);
      stmts.push((0, _blocks.toStatement)((0, _astLocUtils.placeAtLoc)(_types2.default.assignmentExpression("=", (0, _astLocUtils.placeAtLoc)(_types2.default.memberExpression(ref, _property.key, _property.computed), loc), _property.value), loc)));
    }
  } else {
    var _loc = (0, _astLocUtils.getSurroundingLoc)(bundle);
    // _ref.push(bundle...)
    return stmts.push((0, _blocks.toStatement)((0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.memberExpression(ref, (0, _astLocUtils.placeAtLoc)(_types2.default.identifier("push"), _loc)), _loc), bundle), _loc)));
  }
}function transformComprehension(path, isObject) {
  var node = path.node;

  var elements = isObject ? node.properties : node.elements;
  var nodeKey = isObject ? "properties" : "elements";
  var stmts = [];
  var id = (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier(isObject ? "obj" : "arr")), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));

  var i = 0,
      len = elements.length,
      bundle = [],
      first = true,
      initializer = void 0;
  while (i < len) {
    var element = elements[i];
    if ((0, _is.isa)(element, "Comprehension")) {
      if (first) {
        initializer = bundle;
        first = false;
      } else {
        if (bundle.length > 0) pushBundle(stmts, id, bundle, isObject);
      }bundle = [];

      if ((0, _is.isa)(element, "LoopComprehension")) {
        transformLoop(path.get(`${nodeKey}.${i}`), id, isObject, stmts);
      } else if ((0, _is.isa)(element, "CaseComprehension")) {
        transformCase(path.get(`${nodeKey}.${i}`), id, isObject, stmts);
      } else {
        throw new Error("Invalid comprehension node (this is an internal error)");
      }
    } else {
      bundle.push(element);
    }i++;
  }if (bundle.length > 0) pushBundle(stmts, id, bundle, isObject);

  var initializerLoc = initializer.length === 0 ? (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1) : (0, _astLocUtils.getSurroundingLoc)(initializer);

  var finalInitializer = isObject ? (0, _astLocUtils.placeAtLoc)(_types2.default.objectExpression(initializer), initializerLoc) : (0, _astLocUtils.placeAtLoc)(_types2.default.arrayExpression(initializer), initializerLoc);

  return path.replaceWith(iife(stmts, id, finalInitializer));
}function transformArrayComprehension(path) {
  transformComprehension(path, false);
}function transformObjectComprehension(path) {
  transformComprehension(path, true);
}function transformPlainArrayComprehension(path) {
  // Shim V1 onto V2
  var node = path.node;
  var loop = node.loop;

  if (loop) {
    delete node.loop;
    // TODO: fix babel patch so there's a builder for this...
    node.elements = [(0, _astLocUtils.placeAtNode)({
      type: "LoopComprehension",
      loop
    }, node)];
    path.replaceWith(node);
    transformArrayComprehension(path);
  }
}function transformPlainObjectComprehension(path) {
  // Shim V1 onto V2
  var node = path.node;
  var loop = node.loop;

  if (loop) {
    delete node.loop;
    // TODO: fix babel patch so there's a builder for this...
    node.properties = [(0, _astLocUtils.placeAtNode)({
      type: "LoopComprehension",
      loop
    }, node)];
    path.replaceWith(node);
    transformObjectComprehension(path);
  }
}